import { render, staticRenderFns } from "./UnsubscribeTemplate.vue?vue&type=template&id=6fb3db11&scoped=true"
import script from "./UnsubscribeTemplate.vue?vue&type=script&lang=ts"
export * from "./UnsubscribeTemplate.vue?vue&type=script&lang=ts"
import style0 from "./UnsubscribeTemplate.vue?vue&type=style&index=0&id=6fb3db11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb3db11",
  null
  
)

export default component.exports